import React from "react";
import { useHistory } from "react-router-dom";
import Footer from "../layout/Footer";
import Header from "../layout/Header";

const MenuCard = ({ icon, title, subtitle, onClick }) => (
  <a onClick={onClick} href="javascript:;" className="col-6">
    <div className="card card-style mb-3">
      <i className={`fas ${icon} fa-3x mt-5`}></i>
      <h3 className="pt-4">{title}</h3>
      <p className="font-11 opacity-50 mt-n2">{subtitle}</p>
      <p className="mb-0 pb-0 font-10 opacity-40">Tap to View</p>
    </div>
  </a>
);

const Objective = (props) => {
  const history = useHistory();
  const showSources = props.sources;
  return (
    <div id="page">
      <Header
        onBack={() => (showSources ? props.setstep("objective") : history.push("/choosetype"))}
      />
      <Footer />
      <div className="page-content header-clear-medium">
        {showSources ? (
          <>
            <div className="row mb-0">
              <div className="col-md-12 text-center">
                <h3 className="m-3">Plotting Discontinuity Trace</h3>
              </div>
            </div>
            <div className="row text-center mb-3 justify-content-center">
              <MenuCard
                icon="fa-grip-lines-vertical color-magenta-dark"
                title="Plotting from Known Orientation"
                subtitle="Plotting Discontinuity Trace for vertical shaft"
                onClick={() => props.setstep("vertical_shaft")}
              />
              <MenuCard
                icon="fa-slash color-highlight"
                title="Plotting from Known Disposition"
                subtitle="Plotting Discontinuity Trace for vertical shaft"
                onClick={() => props.setstep("computing")}
              />
            </div>
          </>
        ) : (
          <>
            <div className="row mb-0">
              <div className="col-md-12 text-center">
                <span className="m-3">Choose the type of activity:</span>
              </div>
            </div>
            <div className="row text-center mb-3 justify-content-center">
              <MenuCard
                icon="fa-chart-area color-magenta-dark"
                title="Plotting Discontinuity Trace"
                subtitle="Plotting Discontinuity Trace on the Shaft Log"
                onClick={() => props.setstep("sources")}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Objective;
